import { Config, Env } from "@greeter/config";
import config from "../../../config.json" with { type: "json" };
import env from "../../../environment.json" with { type: "json" };
import firebaseConfig from "../../../firebase-config";

export function getConfig() {
  return config as Config;
}

export function getFirebaseConfig() {
  return firebaseConfig;
}

export function getEnv() {
  return env.environment as Env;
}
